import React from "react";
import { NavLink } from "react-router-dom";

const CounterCard = ({ name, number, icon, background = "primary", linkto = "#" }) => {
  let className="card-counter " + background;
  return (
    <NavLink to={linkto} >
      <div 
        className={className} 
        style={{ cursor: "pointer" }}
      >
        {icon}
        <span className="count-numbers">{Intl.NumberFormat().format(number)}</span>
        <span className="count-name">{name}</span>
      </div>
    </NavLink>
  );
};

export default CounterCard;